import { GetCustomizeCar_customizeCar_images } from '../graphql/queries/__generated__/GetCustomizeCar';
import { ImageType } from '../../gqlCommon/enum/ImageType';

const imagesService = {
  interiorImage: (images: GetCustomizeCar_customizeCar_images[]): string =>
    images?.find(image => image.type === ImageType.INTERIOR)?.url,
  panoramicInteriorImage: (images: GetCustomizeCar_customizeCar_images[]): string =>
    images?.find(image => image.type === ImageType.INTERIOR_360_PANORAMIC)?.url,
  exteriorImagesUrls: (images: GetCustomizeCar_customizeCar_images[], first360Image: string): string[] => {
    let exterior360ImagesData = images?.filter(image => image.type.includes(ImageType.EXTERIOR_360)) || [];

    if (first360Image) {
      const rotatedIndex = exterior360ImagesData?.findIndex(image => image.type === first360Image);

      if (rotatedIndex !== -1) {
        exterior360ImagesData = [
          ...exterior360ImagesData.slice(rotatedIndex),
          ...exterior360ImagesData.slice(0, rotatedIndex),
        ];
      }
    }

    return exterior360ImagesData?.map(image => image.url);
  },
};

export default imagesService;
